import { Pegasus } from 'corso-types';
import { type SimpleSelectOption } from 'corso-admin-ui';

export const CUSTOM_PARCEL_NAME = 'Custom Parcel';

export const CUSTOM_PARCEL = {
  name: CUSTOM_PARCEL_NAME,
  length: 10,
  width: 10,
  height: 10,
};

export const predefinedParcels = [
  CUSTOM_PARCEL,
  { name: 'FedEx Small Box', length: 12.25, width: 10.9, height: 1.5 },
  { name: 'FedEx Medium Box', length: 13.25, width: 11.5, height: 2.38 },
  { name: 'FedEx Large Box', length: 17.88, width: 12.38, height: 3 },
  { name: 'UPS Small Box', length: 13, width: 11, height: 2 },
  { name: 'UPS Medium Box', length: 16, width: 11, height: 3 },
  { name: 'UPS Large Box', length: 18, width: 13, height: 3 },
  { name: 'UPS Extra Large Box', length: 18, width: 13, height: 6 },
  { name: 'UPS Tube', length: 38, width: 6, height: 6 },
] satisfies Pegasus.Parcel[];

export const parcelSelectOptions = predefinedParcels.map((parcel) => ({
  label: (
    <div className="flex flex-col items-start">
      <span>{parcel.name}</span>
      {parcel.name !== CUSTOM_PARCEL_NAME && (
        <span className="text-xs">
          {parcel.length} x {parcel.width} x {parcel.height} in
        </span>
      )}
    </div>
  ),
  value: parcel.name,
})) satisfies SimpleSelectOption[];

export const findPredefinedParcelByDimensions = ({
  length,
  width,
  height,
}: Pick<Pegasus.Parcel, 'length' | 'width' | 'height'>) =>
  predefinedParcels.find(
    (p) =>
      p.name !== CUSTOM_PARCEL_NAME &&
      p.length === length &&
      p.width === width &&
      p.height === height,
  );
